var _path, _ellipse, _ellipse2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9 21H2c-1 0-2-1-2-2.2V2.2C0 1 1 0 2.1 0H28c1 0 2 1 2 2.2v16.6c0 1.2-1 2.2-2.1 2.2z",
    fill: "#16786C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5,
    cy: 5.9,
    rx: 2.6,
    ry: 2.7,
    fill: "#FF8856"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.2,
    cy: 5.9,
    rx: 2.6,
    ry: 2.7,
    fill: "#FDEEE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 12.6h-5a1 1 0 01-1.1-1c0-.7.5-1.2 1-1.2h5c.7 0 1.1.5 1.1 1.1 0 .6-.4 1.1-1 1.1zm-2 5.6H4a1 1 0 01-1.1-1c0-.7.5-1.2 1-1.2H7c.6 0 1 .5 1 1.1s-.4 1.1-1 1.1zm6.5 0h-3.2a1 1 0 01-1-1c0-.7.5-1.2 1-1.2h3.2c.5 0 1 .5 1 1.1s-.5 1.1-1 1.1zm6.3 0h-3a1 1 0 01-1.1-1c0-.7.5-1.2 1-1.2h3.1c.6 0 1.1.5 1.1 1.1s-.5 1.1-1 1.1zm6.4 0h-3a1 1 0 01-1.1-1c0-.7.4-1.2 1-1.2h3.1c.6 0 1.1.5 1.1 1.1s-.5 1.1-1 1.1z",
    fill: "#D9EAE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.82607fdb5bd1cabac58f6001838c7536.svg";
export { ForwardRef as ReactComponent };